// extracted by mini-css-extract-plugin
export default {"GaugesContainer":"MyGauge_GaugesContainer__tdrTJ","GaugeItemo":"MyGauge_GaugeItemo__SAzsO","GaugeItemo2":"MyGauge_GaugeItemo2__tDEEn","GaugeOverflow":"MyGauge_GaugeOverflow__3i6v+"};